/// <reference path="scripts/angular.min.js" />
/// <reference path="scripts/angular-route.min.js" />

angular.module("dentist", ['ui.router', 'pascalprecht.translate', 'smoothScroll', 'angular.filter', 'ngAnimate'])
.run(function ($rootScope, $http) {
    $rootScope.isLoading = true;
    //$rootScope.ServerUrl = "";

})
.config(['$httpProvider', '$translateProvider', '$animateProvider', function ($httpProvider, $translateProvider, $animateProvider) {

    // restrict animation to elements with the zum-animate css class with a regexp.
    $animateProvider.classNameFilter(/zum-animate/);

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.translations('en', {
        "EMERGENCY_NEW": 'emergency new',
        NOAPPOINTMENT: 'No available appointments',
        from: 'from ',
        to:'to ',
        TITLE: 'Select appointment',
        DETAIL: 'Enter details',
        "done.Confirmation": 'Confirmation',
        SHOWMOREP: 'Show more practioners',
        SHOWLESSP: 'Show less practioners',
        SHOWMORES: 'Show more services',
        SHOWLESSS: 'Show less services',
        PWEEK: 'Previous Week',
        NWEEK: 'Next Week',
        APPOINTMENT: 'Your Appointment',
        MAKEAPP: 'Please make an appointment!',
        WANT: 'I want this',
        WITH: 'with',
        ON: 'on',
        AT: 'at',
        ENTER: 'Please enter your details',
        "detail.Comment": 'Your message for the practice (optional)',
        PleaseConfirm: 'Please confirm.',
        ALREADY: 'Already a customer',
        EMAIL: 'e-mail',
        CONFIRM: 'Confirm e-mail',
        Info: 'Information must be indicated',
        Salutation: 'Salutation',
        Salutation_MR: 'MR',
        Salutation_MS: 'MS',
        Fname: 'First Name',
        Lname: 'Last Name',
        Address: 'Address (Street, no.)',
        StreetNo: 'Street number',
        PostalCode: 'Postal Code',
        City: 'City',
        CBooking: 'Confirm Booking',
        Password: 'Password',
        Login: 'Login',
        Thanks: 'Thank you, your appointment is now confirmed',
        EmailSent: 'A confirmation with the details of your appointment has been sent to your email address',
        Hello: 'Hello',
        ChangeData: 'If you want, you can change your data here:',
        Change:'Change',
        Welcome: 'Welcome back!',
        Choose:'Select Period',
        SelectService: 'Select service first',
        ShowMore: 'Show more',
        TeimframeNoFree: 'No free appointments in this period.',
        NextFree: 'Next free appointments on',
        FirstFree: 'Last free appointments on',
        SelectServicePlz: 'Please select a service',
        SelectDateTime: 'Please select a date and time',
        ShowThisWeek: 'Show this week',
        CopyRight: 'Copyright and Powered by',
        PrivacyStatement: 'Privacy Statement',
        ChooseService: 'Select a service',
        ChoosePractitioner: 'Select a practitioner (Optional)',
        Agreement: 'I agree with the ',
        Praxisbestimmungen: 'practice terms',
        Datenschutzerkl: 'privacy policy',
        Agb: 'general terms and conditions',
        "detail.PayNow": 'Pay now',
        "detail.PayLater": 'Pay later',
        "detail.UseVoucher": 'apply',
        "detail.showVoucher": 'use voucher',
        "detail.Price": 'Price',
        "detail.VoucherIncorrect": 'No corresponding coupon available',
        "detail.RemoveVoucher": 'Remove',
        "disclaimer.onlyForNewPatients":'for new patients',
        "DR": 'Dr.',
        "DR_MED": 'Dr. med.',
        "DR_MED_DENT": 'Dr. med. dent.',
        "MED_DENT": 'med. dent.'
    })
         .translations('de', {
             "EMERGENCY_NEW": "Notfall",
             "EMERGENCY_EXISTING": "Notfall oder Zahnschmerzen wiederkehrender Patient",
             "DENTAL_HYGIENE": "Dentalhygiene",
             "DENTAL_HYGIENE_DH": "Dentalhygiene bei DH",
             "CHECK_UP": "Zahnärztliche Kontrolle",
             "CHECK_UP_NEW": "Zahn-Check / Kontrolle",
             "CHECK_UP_EXISTING": "Kontrolle wiederkehrender Patient",
             "ZUMEDO_DEMO_ZH": "Vorführung Zumedo Portal ZÜRICH",
             "ZUMEDO_DEMO_BE": "Vorführung Zumedo Portal BERN",
             "ZUMEDO_CONSULTING_ZH": "Beratung online Akquise ZÜRICH",
             "DENTIST_MR": "Zahnarzt",
             "DENTIST_MS": "Zahnärztin",
             "DENTAL_HYGIENIST_MR": "Dentalhygieniker",
             "DENTAL_HYGIENIST_MS": "Dentalhygienikerin",
             "PROPHYLAXIS_ASSISTANT_MR": "Prophylaxeassistent",
             "PROPHYLAXIS_ASSISTANT_MS": "Prophylaxeassistentin",
             "DENTAL_ASSISTANT_MR": "Dentalassistent",
             "DENTAL_ASSISTANT_MS": "Dentalassistentin",
             "ORTHODONTIST_MR": "Kieferorthopäde",
             "ORTHODONTIST_MS": "Kieferorthopädin",
             "ZUMEDO_MR": "Zumedo",
             "ZUMEDO_MS": "Zumedo",
             "CHECK_UP_HYGIENE": "Kontrolle und Dentalhygiene",
             "CHECK_UP_HYGIENE_PA": "Kontrolle und Dentalhygiene bei PA",
             "APPOINTMENT": "Termin",
             "CONSULT_BRACE": "Erstberatung Zahnspange / Invisalign",
             "CONSULT_IMPLANT": "Erstberatung Implantat",
             "CONSULT_BRIDGE": "Erstberatung Brücke",
             "TOOTH_BROKEN": "Abgebrochener Zahn",
             "BLEACHING": "Bleaching In-Office",
             "BLEACHING_HOME": "Bleaching Home",
             "VENEER": "Erstberatung Veneer",
             "CROWN": "Erstberatung Krone / Brücke",
             "EMERGENCY": "Notfall oder Zahnschmerzen",
             "FILLING": "Problem mit Füllung",
             "ROOT": "Erstberatung Wurzelbehandlung",
             "PAIN": "Zahnschmerzen",
             "SECOND_OPINION": "Zweitmeinung",
             "GUM_PROBLEM": "Zahnfleischproblem",
             "WISDOM_TOOTH": "Erstberatung Weisheitszahn",
             "OTHER": "Anderes / Beratung",
             "SECOND_OPINION_ORTHODONTICS": "Zweitmeinung Kieferorthopädie",
             "CONSULT_ORTHODONTICS": "Erstberatung Kieferorthopädie",
             NOAPPOINTMENT: 'Keine Termine verfügbar. Wählen Sie eine andere Behandlung oder Praktizierende/n.',
             "zuerich": "Zürich",
             "bern": "Bern",
             "basel": "Basel",
             "luzern": "Luzern",
             "winterthur": "Winterthur",
             "zug": "Zug",
             "chur": "Chur",
             "st-gallen": "St. Gallen",
             "schaffhausen": "Schaffhausen",
             "thun": "Thun",
             "nidwalden": "Nidwalden",
             "aargau": "Aargau",
             "biel": "Biel",
             "appenzellerland": "Appenzellerland",
             "solothurn": "Solothurn",
             from: 'ab ',
             to: 'bis ',
             TITLE: 'Termin wählen',
             DETAIL: 'Details eingeben',
             "done.Confirmation": 'Bestätigung',
             SHOWMOREP: 'Mehr Praktizierende anzeigen',
             SHOWLESSP: 'Weniger anzeigen',
             SHOWMORES: 'Mehr Behandlungen anzeigen',
             SHOWLESSS: 'Weniger Behandlungen anzeigen',
             PWEEK: 'letzte Woche',
             NWEEK: 'nächste Woche',
             APPOINTMENT: 'Ihr Termin',
             MAKEAPP: 'Bitte vereinbaren Sie einen Termin!',
             WANT: 'Weiter',
             WITH: 'bei',
             ON: 'am',
             AT: 'um',
             ENTER: 'Bitte tragen Sie Ihre Angaben ein',
             PleaseConfirm: 'Bitte bestätigen.',
             ALREADY: 'Bereits Patient',
             EMAIL: 'E-Mail',
             CONFIRM: 'E-Mail bestätigen',
             "detail.Comment" : 'Ihre Nachricht an die Praxis (optional)',
             Info: 'Informationen müssen angegeben werden',
             Salutation: 'Anrede',
             Salutation_MR: 'Herr',
             Salutation_MS: 'Frau',
             Fname: 'Vorname',
             Lname: 'Nachname',
             Address: 'Adresse (Strasse, Nr.)',
             StreetNo: 'Hausnummer',
             PostalCode: 'Postleitzahl',
             City: 'Stadt',
             CBooking: 'Ich bestätige diese Buchung',
             Password: 'Passwort',
             Login: 'Anmeldung',
             Thanks: 'Vielen Dank, Ihre Termin-Buchung ist jetzt abgeschlossen.',
             EmailSent: 'Eine Bestätigung mit den Details Ihres Termins wurde an Ihre E-Mail-Adresse gesendet.',
             Hello: 'Hallo',
             ChangeData: 'Wenn Sie möchten, können Sie hier Ihre Daten ändern:',
             Welcome: 'Willkommen zurück!',
             Change:'Ändern',
             Choose: 'Zeitraum ändern',
             SelectService: 'Wählen Sie zuerst eine Dienstleistung aus',
             ShowMore: 'Mehr anzeigen',
             TeimframeNoFree: 'Keine freien Termine in diesem Zeitraum.',
             NextFree: 'Zum nächsten freien Termin',
             FirstFree: 'Zum vorherigen freien Termin',
             SelectServicePlz: 'Bitte wählen Sie zuerst eine Behandlung bei Schritt 1.',
             SelectDateTime: 'Bitte wählen Sie ein Datum und eine Uhrzeit',
             ShowThisWeek: 'Aktuelle Woche anzeigen',
             CopyRight: 'Copyright ',
             PrivacyStatement: 'Datenschutzerklärung',
             ChooseService: 'Wählen Sie eine Behandlung',
             ChoosePractitioner: 'Wählen Sie einen Praktizierenden (Optional)',
             Agreement: 'Ich bestätige, die ',
             Praxisbestimmungen: 'Praxisbestimmungen',
             Datenschutzerkl: 'Datenschutzerklärungen',
             Agb: 'Allgemeinen Geschäftsbedingungen',
             "detail.PayNow": 'Jetzt bezahlen',
             "detail.PayLater": 'Später bezahlen',
             "detail.UseVoucher": 'Anwenden',
             "detail.showVoucher": 'Gutschein einlösen',
             "detail.Price": 'Preis',
             "detail.VoucherIncorrect": 'Kein entsprechender Gutschein vorhanden',
             "detail.RemoveVoucher": 'Entfernen',
             "disclaimer.onlyForNewPatients":'für Neupatienten',
             "DR": 'Dr.',
             "DR_MED": 'Dr. med.',
             "DR_MED_DENT": 'Dr. med. dent.',
             "MED_DENT": 'med. dent.'
         });
    var language = localStorage.getItem("lang");
    if(language==null)
        $translateProvider.preferredLanguage('de');
    else
        $translateProvider.preferredLanguage(language);

}])


.directive('ngMatch', ['$parse', function ($parse) {

    var directive = {
        link: link,
        restrict: 'A',
        require: '?ngModel'
    };
    return directive;

    function link(scope, elem, attrs, ctrl) {
        // if ngModel is not defined, we don't need to do anything
        if (!ctrl) return;
        if (!attrs['ngMatch']) return;

        var firstPassword = $parse(attrs['ngMatch']);

        var validator = function (value) {
            var temp = firstPassword(scope),
            v = value === temp;
            ctrl.$setValidity('match', v);
            return value;
        }

        ctrl.$parsers.unshift(validator);
        ctrl.$formatters.push(validator);
        attrs.$observe('ngMatch', function () {
            validator(ctrl.$viewValue);
        });

    }
}])

.directive('datePicker', ['$parse', function ($parse) {

    var directive = {
        link: link,
        restrict: 'A',
    };
    return directive;

    function link(scope, elem, attrs, ctrl) {
        // if ngModel is not defined, we don't need to do anything

        $(elem).datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: new Date(),
            todayBtn: "linked",
            todayHighlight: true,
            language: 'de'
        }).on('changeDate', function (ev) {
            scope.$emit("UpdatingDate", ev.date);
        });
    }
}]);

angular.module('dentist').filter('showDate', function () {
    return function (timeObj, format) {
        var Language = localStorage.getItem("lang");
        if (timeObj != null)
            if (Language == "de")
                return moment(timeObj, "dddd MM/DD/YYYY", "de").lang("de").format(format);
            else
                return moment(timeObj, "dddd MM/DD/YYYY", "en").lang("en").format(format);
        else
            return null;
    };
});
angular.module('dentist').filter('showTime', function () {
    return function (timeObj, format) {
        var Language = localStorage.getItem("lang");
        if (timeObj != null)
            if (Language == "de")
                return moment.utc(timeObj, "dddd MM/DD/YYYY HH:mm:ss", "de").lang("de").local().format(format);
            else
                return moment.utc(timeObj, "dddd MM/DD/YYYY HH:mm:ss", "en").lang("en").local().format(format);
        else
            return null;
    };
});
function uiBlock(msg, el, loaderOnTop) {
    lastBlockedUI = el;
    if (msg == '' || msg == null || msg == "") {
        msg = "LOADING";
    }
    if (el) {
        jQuery(el).block({
            //class="loading-message loading-message-boxed"  style="margin-top:38%" <span>&nbsp;&nbsp;' + msg + '...</span>
            message: '<div  style="z-index:999999 !important"><img src="img/loader.gif" align="absmiddle"></div>',
            baseZ: 2000,
            css: {
                border: 'none',
                padding: '2px',
                backgroundColor: 'none',
            },
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.05,
                cursor: 'wait'
            }
        });
    } else {
        if (msg == '' || msg == null || msg == "") {
            msg = "LOADING";
        }
        $.blockUI({
            //class="loading-message loading-message-boxed"  style="margin-top:38%;"  <span>&nbsp;&nbsp;' + msg + '...</span>
            message: '<div style="z-index:999999 !important"><img src="img/loader.gif" align="absmiddle"></div>',
            baseZ: 2000,
            css: {
                border: 'none',
                padding: '2px',
                backgroundColor: 'none'
            },
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.05,
                cursor: 'wait'
            }
        });
    }
}

function uiUnBlock(msg, el) {
    if (msg == '' || msg == null || msg == "") {
        msg = "LOADING";
    }
    if (el) {
        jQuery(el).unblock({
            onUnblock: function () {
                jQuery(el).removeAttr("style");
            }
        });
    }
    else {
        $.unblockUI();
    }
}
